import React, {Component} from 'react';
import { observer, inject } from 'mobx-react';

import './ZoomControl.css';

@inject("appStore")
@observer
class ZoomControl extends Component {
    zoomIn = () =>{
        this.props.appStore.mapState.element.zoomIn();
    };
    zoomOut = () =>{
        this.props.appStore.mapState.element.zoomOut();
    };
    render() {
        return (
            <div className="ZoomControl">
                <button className="zoom-in" aria-label="Zoom in" onClick={this.zoomIn}>+</button>
                <button className="zoom-out" aria-label="Zoom out" onClick={this.zoomOut}>−</button>
            </div>
        );
    }
}

export default ZoomControl;





// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/ZoomControl/index.js